import { IntervalView } from "../interface/interfaces";

export function calculateActiveHours(intervals: IntervalView[]): string {
  if (!intervals?.length) return '0h 0m';
  const validIntervals = intervals.filter(i => i.inicio?.dTiempo_Marca && i.fin?.dTiempo_Marca);
  if (!validIntervals.length) return '0h 0m';
  let totalMinutes = 0;
  for (const interval of validIntervals) {
    const start = new Date(interval.inicio!.dTiempo_Marca);
    start.setSeconds(0, 0);
    const end = new Date(interval.fin!.dTiempo_Marca);
    end.setSeconds(0, 0);
    const diffMinutes = Math.floor((end.getTime() - start.getTime()) / 60000);
    if (diffMinutes > 0) totalMinutes += diffMinutes;
  }
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes}m`;
}